import React from 'react'
import Nav from '../Components/Nav'
import ArticleMain from '../Components/ArticleMain'
import Footer from '../Components/Footer'
import { recentPost, postDetails} from "../Components/Lists/articleEndocarditis"
import GoToTop from '../Components/GoToTop'

const ArticleEndocarditis = () => {
  return (
    <>
    <Nav/>
    <ArticleMain recentPost={recentPost} postDetails={postDetails}/>
    <Footer/>
    <GoToTop/>
    </>
  )
}

export default ArticleEndocarditis